























import { TTableColumn, TTableColumns } from '@/components/table/types';
import { TTableVisiblePayload } from '@/components/table/types';
import Vue, { PropType } from 'vue';

export default Vue.extend({
  name: 'TableToolColumns',

  props: {
    columns: {
      type: Array as PropType<TTableColumns>,
      required: true,
    },
  },

  methods: {
    closeModal() {
      this.modal = false;
    },
    select(column: TTableColumn) {
      const payload: TTableVisiblePayload= {
        field: column.field,
        visible: !column.visible,
      };

      this.$emit('change', payload);
    },
  },

  data() {
    return {
      modal: false,
    };
  },
});
